import React from 'react';
import { DotStatus, HeaderFilterTable, Icon } from '@/components/common';
import { ClientDirectoryFiltersType } from '@/interfaces';
import { useFilters } from '@/hooks';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';

interface Props {
	title: string;
	filterKey: ClientDirectoryFiltersType;
	totalFilterKey: ClientDirectoryFiltersType;
}

export const ClientTasksFilter: React.FC<Props> = ({
	title,
	filterKey,
	totalFilterKey,
}) => {
	const { setParamSeveralFilters, hasFilter } = useFilters();

	const filters: Options[] = [
		{
			label: '0 Tasks',
			value: '0',
			icon: (
				<Icon
					src={Icons.note}
					width={18}
					height={18}
					className="text-primary"
				/>
			),
		},
		{
			label: '1 Task',
			value: '1',
			icon: (
				<Icon
					src={Icons.note}
					width={18}
					height={18}
					className="text-primary"
				/>
			),
		},
		{
			label: '+2 Tasks',
			value: '2',
			icon: (
				<Icon
					src={Icons.note}
					width={18}
					height={18}
					className="text-primary"
				/>
			),
		},
		{
			label: 'In Progress',
			value: 'IN_PROGRESS',
			icon: <DotStatus color="green" />,
		},
		{
			label: 'Action Required',
			value: 'ACTION_REQUIRED',
			icon: <DotStatus color="red" />,
		},
		{
			label: 'On Hold',
			value: 'ON_HOLD',
			icon: <DotStatus color="orange" />,
		},
	];

	const handleSelectFilters = (value?: string) => {
		// specials filters
		switch (value) {
			case '0':
			case '1':
			case '2':
				if (value === '0' || value === '1' || value === '2') {
					setParamSeveralFilters([
						{ label: filterKey, value: '' },
						{ label: totalFilterKey, value: value },
					]);
				}
				break;

			default:
				setParamSeveralFilters([
					{ label: filterKey, value: value },
					{ label: totalFilterKey, value: '' },
				]);
				break;
		}
	};

	const handleClearAll = () => {
		setParamSeveralFilters([
			{ label: filterKey, value: '' },
			{ label: totalFilterKey, value: '' },
		]);
	};

	return (
		<HeaderFilterTable
			title={title}
			searchTitle="Tasks"
			filterOptions={filters}
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter(filterKey) || hasFilter(totalFilterKey)}
			classNamePopoverContent="lg:w-[262px]"
		/>
	);
};
